import styles from "./AllScheduledMovementse.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";

const data = [
  {
    _id: "1",
    programName: "Program 1",
    currentProgram: "Annual day",
    nextProgram: 0,
    movementDate: "24/05/25",
  },
  {
    _id: "2",
    programName: "Program 2",
    currentProgram: "Summer Camp",
    nextProgram: 1,
    movementDate: "26/05/25",
  },
];
  

function AllScheduledMovements() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);


  const handleConfirm = (item) => {
    console.log(`Confirmed for: ${item.programName}`);
    // You can perform additional logic like API call or status update here
  };
  
  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      const cellStyle = { color: "var(--Grey_Color)" };

      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),

        programName: (
          <span style={{ color: "var(--Primary_Color)", fontWeight: 400 }}>
            {item.programName}
          </span>
        ),

        currentProgram: <span style={cellStyle}>{item.currentProgram}</span>,
        nextProgram: <span style={cellStyle}>{item.nextProgram}</span>,
        movementDate: <span style={cellStyle}>{item.movementDate}</span>,

        confirmButton: (
          <button
            onClick={() => handleConfirm(item)}
            style={{
              padding: "0.5rem 1.2rem",
              borderRadius: "1.5rem",
              background: "var(--Utility_Color1)",
              border: "none",
              color: "var(--Black_Color)",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              transition: "background 0.2s ease",
            }}
          >
            Confirm
          </button>
        ),

        action: (
          <Action
            key={item._id}
            options={item.actionOptions || ["Edit", "Delete"]}
            onSelect={(opt) => {
              if (opt === "Edit") dispatch(openModal("TransferStudent"));
              else if (opt === "Transfer")
                dispatch(openModal("TransferStudent"));
              else if (opt === "Delete") dispatch(openModal("delete"));
            }}
          />
        ),
      };
    });
  };
  
  
  const displayData = getColumnData(data);

 

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Program Name", accessor: "programName" },
    { title: "Current Program", accessor: "currentProgram" },
    { title: "Next Program", accessor: "nextProgram" },
    { title: "Movement Date", accessor: "movementDate" },
    { title: "", accessor: "confirmButton" }, // Empty title
    { title: "Action", accessor: "action" },
  ];
  
  
  return (
    <div className={styles.headerContainer}>
      {/* Status boxes */}
      

      {/* Search and Filters */}
      <div className={styles.totalstudentcard}>
        <div className={styles.studentsection}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search Student"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.filters}>
            <Dropdown
              label="Current Program"
              options={["1", "2", "3"]}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Rule Type"
              options={[" 1", "2"]}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Time Range"
              options={["1 to 3 ", "2"]}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            
          </div>
        </div>

        {/* Student Data Table */}
        <div className={styles.dynamicdata}>
          <Dynamic
            headings={headingsData}
            columnData={displayData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
        </div>
        <div className={styles.paginationTable}>
          <PaginationTable
            data={displayData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default AllScheduledMovements;
